import * as React from 'react';
import { Widget } from '../types';
import AbsenceBalanceWidget from './AbsenceBalanceWidget';
import TimeTrackingWidget from './TimeTrackingWidget';
import ActionConfirmationWidget from './ActionConfirmationWidget';
import UpcomingScheduleWidget from './UpcomingScheduleWidget';
import AnalyticsStatWidget from './AnalyticsStatWidget';
import AbsenceListWidget from './AbsenceListWidget';
import ExpenseListWidget from './ExpenseListWidget';
import PersonCardWidget from './PersonCardWidget';
import SkillPeopleWidget from './SkillPeopleWidget';
import DocumentListWidget from './DocumentListWidget';
import TicketListWidget from './TicketListWidget';

type Props = {
  widget: Widget;
};

const WidgetRenderer: React.FC<React.PropsWithChildren<Props>> = ({
  widget,
}) => {
  switch (widget.type) {
    case 'absence_balance':
      return <AbsenceBalanceWidget data={widget.data} />;
    case 'time_tracking_status':
      return <TimeTrackingWidget data={widget.data} />;
    case 'action_confirmation':
      return <ActionConfirmationWidget data={widget.data} />;
    case 'upcoming_schedule':
      return <UpcomingScheduleWidget data={widget.data} />;
    case 'analytics_stat':
      return <AnalyticsStatWidget data={widget.data} />;
    case 'absence_list':
      return <AbsenceListWidget data={widget.data} />;
    case 'expense_list':
      return <ExpenseListWidget data={widget.data} />;
    case 'person_card':
      return <PersonCardWidget data={widget.data} />;
    case 'skill_people':
      return <SkillPeopleWidget data={widget.data} />;
    case 'document_list':
      return <DocumentListWidget data={widget.data} />;
    case 'ticket_list':
      return <TicketListWidget data={widget.data} />;
    default:
      return null;
  }
};

export default WidgetRenderer;
